module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/folder-star-21d06250622105bba97603e5c5e5123c.svg";